import { grey } from './colors';
export const text = (mode)=>{
    const accent = grey[300];
    return mode === 'light' ? {
        primary: grey[950],
        secondary: grey[600],
        disabled: grey[300],
        inversePrimary: grey[50],
        inverseSecondary: grey[200],
        navigationHeader: grey[200],
        accent
    } : {
        primary: grey[50],
        secondary: grey[200],
        disabled: grey[500],
        inversePrimary: grey[950],
        inverseSecondary: grey[600],
        navigationHeader: grey[200],
        accent
    };
};

//# sourceMappingURL=text.js.map